import {createContext} from 'react'

const defaultAuthContext = null

export const AuthContext = createContext(defaultAuthContext)

export default AuthContext